import axios from "../../../../utils/axiosInceptor";
import { propertyService } from "../../../../configs/constants";

export const removeReview = (id) => {
  return axios.delete(`${propertyService}/property/deleteVisitReview/${id}`);
};
